import { createTaskFilterFunction, RunbookFilterType } from './filters'
import { TaskListTask } from 'main/services/queries/types'

export const level = createTaskFilterFunction('lv', (task: TaskListTask, filters: RunbookFilterType): boolean => {
  return filters.lv !== undefined && filters.lv?.includes(task.level)
})
